module.exports = __webpack_public_path__ + "static/media/close.0df0fa66.svg";